import {
    CLEAN_PATIENT,
    DELETE_PATIENT,
    EDIT_PATIENT,
    FILTER_PATIENTSDATA,
    NEW_PATIENT,
    PATIENT_LOCKED_STATUS,
    PATIENTS_COUNT,
    PATIENTS_DATA,
    PATIENTS_SELECTION,
    PATIENTS_STATUSES
} from "../../constants/Tabs-Action-Types";
import utils from "../../../utils/utils";


const initialState = {
    initiatePatientsData:[],
    patientsData:[],
    filterPatientsData:[],
    selectedPatientsData:[],
    patientsTableFilter:{},
    patientsCount: 0,
    activePatientsCount: 0,
    pendingPatientsCount: 0,
    lockedPatientsCount: 0
};

const getTreatmentDurationLabel = (visit,DateOfActivation) => {
    let TreatmentDuration  =  visit ?  visit['TreatmentDuration']: undefined
    if (DateOfActivation !== null && DateOfActivation !== undefined){
        let total = (TreatmentDuration*30).toString()
        let TreatmentStart = new Date(DateOfActivation);
        let today = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const diffDays = Math.round(Math.abs((today - TreatmentStart) / oneDay)).toString();
        return diffDays + '/' + total + ' Days'

    } else {
        let total = (TreatmentDuration*30).toString()
        return '0/' + total + ' Days'
    }

}

const getTreatmentDuration = (visit,DateOfActivation) => {
    let TreatmentDuration  =  visit ?  visit['TreatmentDuration']: undefined
    if (DateOfActivation !== null && DateOfActivation !== undefined){
        let total = TreatmentDuration*30
        let TreatmentStart = new Date(DateOfActivation);
        let today = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const diffDays = Math.round(Math.abs((today - TreatmentStart) / oneDay)).toString();
        return ((diffDays/total)*100).toFixed(2)
    } else {
        return 0
    }
}

const patientsTableDataReducer = (state = initialState, action)=> {

    switch(action.type){
        case PATIENTS_COUNT: {
            let _idata = JSON.parse(JSON.stringify(action.payload));
            state = {
                ...state,
                patientsCount: _idata
            };
            break;
        }
        case PATIENTS_DATA: {
            let collection = []

            let active = 0
            let pending = 0
            let locked = 0
            let currentYear = new Date().getFullYear();
            action.payload.forEach(patient => {
                let sumDose=0


                let treatments= patient.Patient_treatments?patient.Patient_treatments:[]
                for(let i=0;i<treatments.length;i++){
                    let dose=treatments[i].TreatmentMonthlyDosage==="Other"?treatments[i].TreatmentMonthlyDosageOther:treatments[i].TreatmentMonthlyDosage
                    if(parseInt(dose)){
                        sumDose =sumDose+parseInt(dose)
                    }
                }
                sumDose=sumDose===0?"":sumDose
                let habits=patient.Habits_Medicals?patient.Habits_Medicals[0]:""
                let prescription= habits?habits.Validity_of_prescription:""
                let patientIndication= habits?habits.patient_indication:""
                let preciptionDate = prescription?utils.getDateFormatWithYear(new Date(prescription)):""

                let lastVisitDate= patient.LastVisitDate? patient.LastVisitDate.substring(0, patient.LastVisitDate.indexOf("T")):""

                let dateOfBirth= patient.PII?.Date_of_birth? new Date(patient.PII?.Date_of_birth):""
                let age = dateOfBirth? currentYear-dateOfBirth.getFullYear():""
                let PatientNameSearch= patient.PII?.First_name.toLowerCase() + patient.PII?.Last_name.toLowerCase()
                PatientNameSearch=PatientNameSearch.replaceAll('-','')
                PatientNameSearch=PatientNameSearch.replaceAll(' ','')
                collection.push(
                    {
                        UserStorageID:patient.UserStorageID ,
                        PatientName:patient.PII?.First_name + " " + patient.PII?.Last_name ,
                        Phone_num1:patient.PII?.Phone_num1?.replace("972","0"),
                        PatientNameSearch:PatientNameSearch,
                        Enabled:patient.PII?.User?.Enabled,
                        ID:patient.PII?.ID_passport,
                        Gender: patient.PII?.Gender?patient.PII?.Gender.substring(0,1):"",
                        Age: age===0 ? 1 :age,
                        CannabisPatient:patient.cannabis_patient?"Y":"N",
                        PrescriptionValidity:patient.cannabis_patient?preciptionDate:"",
                        MonthlyDose:patient.cannabis_patient?sumDose:"",
                        LastVisit:lastVisitDate,
/*
                         LastVisit:"",
*/
                        Indication:patient.cannabis_patient?patientIndication:"",
                        Status:"",
                        Warning:"",

                    }
                )
            })

            let _pdata = JSON.parse(JSON.stringify(collection));
            state = {
                ...state,
                initiatePatientsData: _pdata,
                patientsData: _pdata,
                // filterPatientsData: _pdata,
                // patientsCount: collection.length,
                // activePatientsCount: _aadata,
                // pendingPatientsCount: _apdata,
                // lockedPatientsCount: _sldata
            };
            break;
        }
        case NEW_PATIENT: {
            let patient = action.payload
            let patientsData = state.patientsData
            let initiatePatientsData = state.initiatePatientsData

            let PatientNameSearch= patient.First_name.toLowerCase() + patient.Last_name.toLowerCase()
            PatientNameSearch=PatientNameSearch.replaceAll('-','')
            PatientNameSearch=PatientNameSearch.replaceAll(' ','')

            let newData = [{
                UserStorageID:patient.UserStorageID ,
                PatientName:patient.First_name + " " + patient.Last_name ,
                PatientNameSearch:PatientNameSearch ,
                ID:patient.PII?.ID_passport,
                Phone_num1:patient.PII?.Phone_num1?.replace("972","0"),
                Gender: patient.PII?.Gender,
                Age:patient.Age,
                Enabled:1,
                CannabisPatient:patient.cannabis_patient?"Y":"N",
                PrescriptionValidity:patient.cannabis_patient?patient.PrescriptionValidity:"",
                MonthlyDose:patient.cannabis_patient?patient.MonthlyDose:"",
                // LastVisit:patient.LastVisit,
                LastVisit:"",
                Indication:patient.cannabis_patient?patient.Indication:"",
                Status:patient.Status
            }]

            let newpatientsData = patientsData.concat(newData)
            let newinitiatePatientsData = initiatePatientsData.concat(newData)

            let _pdata = JSON.parse(JSON.stringify(newpatientsData));
            let _idata = JSON.parse(JSON.stringify(newinitiatePatientsData));
            state = {
                ...state,
                initiatePatientsData:_idata,
                patientsData : _pdata,
                patientsCount: newinitiatePatientsData.length,
                pendingPatientsCount: state.activePatientsCount+1,
            };
            break;
        }
        case CLEAN_PATIENT:{
            state = {
                ...state,
                patientsTableFilter: {},
                selectedPatientsData:[]
            };
            break;
        }

        case FILTER_PATIENTSDATA: {
            let type = action.searchType
            let payload = action.payload
            let patientsTableFilter = state.patientsTableFilter
            let filteredPatientsData = state.initiatePatientsData
            let visibleFilterData = []
            let visiableData = []
            if (type === 'status' && payload === 'total'){
                delete patientsTableFilter.status
            } else {
                utils.set(patientsTableFilter,type,payload)
            }


            for (const [key, value] of Object.entries(patientsTableFilter)) {
                if (key === 'search'){
                    let val = value.toLowerCase()
                    val=val.replaceAll('-','')
                    val=val.replaceAll(' ','')
                    filteredPatientsData = filteredPatientsData.filter(x =>
                        String(x.PatientName).toLowerCase().indexOf(val) > -1 ||
                        String(x.PatientNameSearch).toLowerCase().indexOf(val) > -1 ||
                        String(x.ID).toLowerCase().indexOf(val) > -1 ||
                        String(x.Phone_num1).toLowerCase().indexOf(val) > -1 ||
                        String(x.Gender).toLowerCase().indexOf(val) > -1 ||
                        String(x.Age).toLowerCase().indexOf(val) > -1 ||
                        String(x.PrescriptionValidity).toLowerCase().indexOf(val) > -1 ||
                        String(x.MonthlyDose).toLowerCase().indexOf(val) > -1 ||
                        String(x.LastVisit).toLowerCase().indexOf(val) > -1||
                        String(x.Indication).toLowerCase().indexOf(val) > -1||
                        String(x.Status).toLowerCase().indexOf(val) > -1||
                        String(x.Warning).toLowerCase().indexOf(val) > -1
                    )
                    visibleFilterData = filteredPatientsData
                }  else {
                    let patients = JSON.parse(JSON.stringify(filteredPatientsData))
                    let valArr = JSON.parse(JSON.stringify(value))

                    let res=[]
                    let patientArr=[]

                    Object.entries(valArr).forEach(([name,value]) => {
                            if (Array.isArray(value)) {
                                if(name==="Age"){
                                }else{
                                    for(let i=0;i<value.length;i++){
                                        if(value){
                                            patientArr = patients.filter(patient => {
                                                let patientVal = patient[name]
                                                return String(patientVal).toLowerCase() === String(value[i]).toLowerCase()
                                            })
                                            res=res.concat(patientArr)
                                        }
                                    }
                                }

                            }
                    })
                    if(res.length>0){
                        filteredPatientsData = res
                    }else{
                        filteredPatientsData = patients

                    }
                }
            }
            visiableData = filteredPatientsData
            let _fpdata = JSON.parse(JSON.stringify(visibleFilterData));
            let _vdata = JSON.parse(JSON.stringify(visiableData));
            let _pfdata = JSON.parse(JSON.stringify(patientsTableFilter));
            state = {
                ...state,
                filterPatientsData: _fpdata,
                patientsData: _vdata,
                patientsTableFilter: _pfdata
            };
            break;
        }

        case PATIENTS_SELECTION:{
            let selection = action.payload
            let initiatePatientsData = state.initiatePatientsData

            let newSelection = []
            Object.entries(selection).forEach(([key,value]) => {
                if (value){
                    let index = initiatePatientsData.findIndex((obj => obj.UserStorageID === key));
                    let name = initiatePatientsData[index].FullName
                    newSelection.push({id:key,name})
                }
            })
            state = {
                ...state,
                selectedPatientsData: newSelection
            };
            break;
        }
        case EDIT_PATIENT: {
            let patient = action.payload
            let patientsData = state.patientsData
            let initiatePatientsData = state.initiatePatientsData
            let locked = state.lockedPatientsCount

            let indexData = patientsData.findIndex((obj => obj.UserStorageID === patient.UserStorageID));
            let indexInit = initiatePatientsData.findIndex((obj => obj.UserStorageID === patient.UserStorageID));

            let isLocked = patientsData[indexData]['Enabled'] === 0

            Object.keys(patient).forEach(key => {
                let newVal = patient[key]
                if (patientsData[indexData][key])
                    patientsData[indexData][key] = newVal
                if (initiatePatientsData[indexInit][key])
                    initiatePatientsData[indexInit][key] = newVal
            })

            if (isLocked && patientsData[indexData]['Enabled'] === 1) locked--
            else if (!isLocked && patientsData[indexData]['Enabled'] === 0 ) locked++


            let _pdata = JSON.parse(JSON.stringify(patientsData));
            let _idata = JSON.parse(JSON.stringify(initiatePatientsData));

            let _sldata = JSON.parse(JSON.stringify(locked));

            state = {
                ...state,
                initiatePatientsData:_idata,
                patientsData : _pdata,
                filterPatientsData: _pdata,
                lockedPatientsCount: _sldata
            };
            break;
        }
        case PATIENT_LOCKED_STATUS: {
            let patient = action.payload
            let patientsData = state.patientsData
            let initiatePatientsData = state.initiatePatientsData

            let indexData = patientsData.findIndex((obj => obj.UserStorageID === patient));
            let indexInit = initiatePatientsData.findIndex((obj => obj.UserStorageID === patient));

            let Enabled = patientsData[indexData]['Enabled']

            patientsData[indexData]['Enabled'] = Enabled === 1?0:1
            initiatePatientsData[indexInit]['Enabled'] = Enabled === 1?0:1


            let _pdata = JSON.parse(JSON.stringify(patientsData));
            let _idata = JSON.parse(JSON.stringify(initiatePatientsData));

            state = {
                ...state,
                initiatePatientsData:_idata,
                patientsData : _pdata,
                filterPatientsData: _pdata,
            };
            break;
        }
        case DELETE_PATIENT: {
            let patientId = action.payload
            let patientsData = state.patientsData
            let initiatePatientsData = state.initiatePatientsData
            let locked = state.lockedPatientsCount
            let active = state.activePatientsCount
            let pending = state.pendingPatientsCount

            let indexData = patientsData.findIndex((obj => obj.UserStorageID === patientId));
            let isLocked = patientsData[indexData]['Enabled'] === 0

            let isActive = patientsData[indexData]['AccountStatus'] === 2
            let isPending = patientsData[indexData]['AccountStatus'] === 1

            let newPatientData = patientsData.filter(patient => patient.UserStorageID !== patientId)
            let newInitiatePatientsData = initiatePatientsData.filter(patient => patient.UserStorageID !== patientId)

            if (isLocked) locked--
            if (isActive) active--
            if (isPending) pending--

            let _pdata = JSON.parse(JSON.stringify(newPatientData));
            let _idata = JSON.parse(JSON.stringify(newInitiatePatientsData));

            let _aadata = JSON.parse(JSON.stringify(active));
            let _apdata = JSON.parse(JSON.stringify(pending));
            let _sldata = JSON.parse(JSON.stringify(locked));
            state = {
                ...state,
                initiatePatientsData:_idata,
                patientsData : _pdata,
                filterPatientsData: _pdata,
                patientsCount: newInitiatePatientsData.length,
                activePatientsCount: _aadata,
                pendingPatientsCount: _apdata,
                lockedPatientsCount: _sldata
            };
            break;
        }
        case PATIENTS_STATUSES: {

            break;
        }
        default:
            break;
    }
    return state;
};
export default patientsTableDataReducer;
